class Downgrade {

    constructor() {
        this.initCancelSubscription();
    }
    initCancelSubscription(){
        const thisClass = this;
        const cancelSubscriptionBtns = document.querySelectorAll('.downgrade-subscription');


        cancelSubscriptionBtns.forEach(c => {
            // Checkbox on click event
            c.addEventListener('click', function (e) {
                //check if the button is disabled
                if(c.disabled) {
                    return;
                }
                c.innerHTML = '<span class="spinner-border w-15px h-15px text-muted align-middle me-2"></span> Downgrade';
                // Show loading indication
                c.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                c.disabled = true;
                //add disabled class to the button
                c.classList.add('disabled-downgrade');
                let organizationID = e.currentTarget.getAttribute('data-value');
                if(organizationID){
                    naja.makeRequest('GET', '?do=getDowngradeInfo', {
                        'organizationID': organizationID
                    }, {
                        history: false // Prevent URL changes in browser history
                    }).then((response) => {
                        if(response){
                            let cancelSubscriptionModal = document.getElementById('downgrade_modal');
                            thisClass.downgradeFormValidation(response.data.maxMembers, response.data.minMembers);
                            const downgradeDialer = document.querySelector("#downgrade-dialer");
                            const ktdialer = new KTDialer(downgradeDialer, {
                                min: response.data.minMembers,
                                max: response.data.maxMembers,
                                step: 1,
                                suffix: "",
                                decimals: 0
                            });
                            ktdialer.on('kt.dialer.changed', function(e) {
                                if(e.value === response.data.maxMembers){
                                    $('#downgrade-container .fv-plugins-message-container').html(
                                        '<div data-field="memberCount" data-validator="lessThan" class="text-danger">The value must be less than or equal to '+response.data.maxMembers+'</div>'
                                    );
                                }
                                else if(e.value === response.data.minMembers){
                                    $('#downgrade-container .fv-plugins-message-container').html(
                                        '<div data-field="memberCount" data-validator="greaterThan" class="text-danger">The value must be greater than or equal to '+response.data.minMembers+'</div>'
                                    );
                                }else{
                                    price.calculate(
                                        response.data.mainProduct,
                                        e.value
                                    );
                                    $('#downgrade-container .fv-plugins-message-container').html('');
                                }

                            });
                            ktdialer.on('kt.dialer.change', function(e) {

                            });
                            KTScroll.createInstances();

                            let price_popover = document.getElementById('price_popover');
                            if(price_popover){
                                new bootstrap.Popover(document.getElementById('price_popover'));
                            }
                            price.calculate(
                                response.data.mainProduct);
                            new bootstrap.Modal(cancelSubscriptionModal).show();
                            // Show loading indication
                            c.setAttribute('data-kt-indicator', 'off');
                            // Disable button to avoid multiple click
                            c.disabled = false;
                            c.innerHTML = 'Downgrade';
                            //remove disabled class from the button
                            c.classList.remove('disabled-downgrade');
                        }
                    });
                }
            });
        });
    }

    downgradeFormValidation(maxMembers, minMembers){
        let form = document.getElementById('frm-downgradeForm-downgradeForm');
        if(form){
            let submitButton = document.getElementById('downgrade_form_submit');

            this.fv = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'memberCount': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required',
                                },
                                greaterThan: {
                                    message: 'The value must be greater than or equal to '+minMembers,
                                    min: minMembers,
                                },
                                lessThan: {
                                    message: 'The value must be less than or equal to '+maxMembers,
                                    max: maxMembers
                                }
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        message: new FormValidation.plugins.Message({
                            clazz: 'text-danger',
                            container: function (field, ele) {
                                return FormValidation.utils.closest(ele, '.fv-message-container');
                            },
                        }),
                    }
                }
            ).on('core.form.validating', function(event) {
                new DismissModal('downgrade_modal').disable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
            }).on('core.form.valid', function(e) {
                // Submit form
                form.submit();
            }).on('core.form.invalid', function(event) {
                new DismissModal('downgrade_modal').enable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
            });
        }
    }
}

let price = {
    calculate : function(mainProduct, newMembers = 0){
        //general price
        //for renewal price

        const vat = mainProduct.vat;
        const duration = mainProduct.duration;
        const gatewayPrice = mainProduct.gatewayPrice;
        const branchPrice = mainProduct.branchPrice;
        const freeGateways = mainProduct.freeGateways;
        const freeBranches = mainProduct.freeBranches;


        if(newMembers > 0){
            mainProduct.startMembers = newMembers;
        }
        const members = mainProduct.startMembers;
        //remove free gateways from the equation
        const gateways = (mainProduct.startGateways - mainProduct.hasGateways) - freeGateways;
        let branches = (mainProduct.startBranches - mainProduct.hasBranches) - freeBranches;
        if(branches < 0) branches = 0;

        let priceFullyWithoutVatMembers = members * mainProduct.monthly;
        let priceFullyWithoutVatGateways = gateways * gatewayPrice;
        let priceFullyWithoutVatBranches = branches * branchPrice;

        let discountPrice = (priceFullyWithoutVatMembers + priceFullyWithoutVatGateways + priceFullyWithoutVatBranches) - ((priceFullyWithoutVatMembers + priceFullyWithoutVatGateways + priceFullyWithoutVatBranches) * mainProduct.discountMonthly);
        let discountPercent = 100 - mainProduct.discountMonthly * 100;
        if (duration === 'Annually') {
            priceFullyWithoutVatMembers = members * mainProduct.annually * 12;
            priceFullyWithoutVatGateways = (gateways * gatewayPrice) * 12;
            priceFullyWithoutVatBranches = (branches * branchPrice) * 12;
            discountPercent = 100 - mainProduct.discountAnnually * 100;
            discountPrice = (priceFullyWithoutVatMembers + priceFullyWithoutVatGateways + priceFullyWithoutVatBranches) - ((priceFullyWithoutVatMembers + priceFullyWithoutVatGateways + priceFullyWithoutVatBranches) * mainProduct.discountAnnually);
        }


        let priceWithVat, priceWithoutVat = priceFullyWithoutVatMembers + priceFullyWithoutVatGateways + priceFullyWithoutVatBranches - discountPrice;
        if (vat > 0) {
            priceWithVat = ((priceFullyWithoutVatMembers - discountPrice) * (vat / 100 + 1)) + priceFullyWithoutVatGateways * (vat / 100 + 1) + priceFullyWithoutVatBranches * (vat / 100 + 1);
        }

        const vatPrice = priceWithVat - (priceFullyWithoutVatMembers + priceFullyWithoutVatGateways + priceFullyWithoutVatBranches - discountPrice);


        this.changeTexts(priceWithoutVat, vatPrice, priceWithVat, vat);
    },
    changeTexts: function(priceWithoutVat, vatPrice, priceWithVat, vatPercent) {
        let price_popover = document.getElementById('price_popover');
        if(price_popover){
            document.getElementById('price_popover').setAttribute('data-bs-content', '$'+priceWithoutVat.toFixed(2)+' + $'+vatPrice.toFixed(2)+' VAT '+vatPercent+'%');
            new bootstrap.Popover(document.getElementById('price_popover'));
        }
        if(priceWithVat){
            document.getElementById('new_price').innerText = '$'+priceWithVat.toFixed(2);
        }else{
            document.getElementById('new_price').innerText = '$'+priceWithoutVat.toFixed(2);
        }
    }
}
window.Downgrade = Downgrade;